import { List, ListType } from '@capital-access/lists/common';
import { ContactInformationDto } from '@capital-access/profiles/common';
import { ContactSuggesterItem } from '../models/contact-suggester-item.model';
import { ListDetails } from '../models/list-details.model';

export const mapContactInformationDtoToContactSuggesterItem = (contact: ContactInformationDto): ContactSuggesterItem =>
  ({
    prId: contact.prEntity?.id,
    crmId: contact.crmEntity?.id,
    name: contact.name,
    compositeKey: contact.id,
    email1: contact.contacts?.email1,
    displaySelectedName: contact.contacts?.email1 || contact.name,
    uniqueRecipientId: `contact|${contact.id}`
  } as ContactSuggesterItem);

export const mapListsToContactSuggesterItem = (list: ListDetails): ContactSuggesterItem =>
  ({
    uniqueRecipientId: `list|${list.listId}`,
    displaySelectedName: `${list.listName} (${list.listCount})`,
    list: {
      id: list.listId,
      name: list.listName,
      itemsCount: list.listCount,
      type: ListType.Contact
    } as List
  } as ContactSuggesterItem);
